import quiz from './quiz'
import api from './api'

export default (state = {}) => ({
  quiz: quiz(state.quiz),
  api: api(state.api),
})
